/**
 * System color-scheme port — web implementation via prefers-color-scheme.
 */
import { useEffect, useState } from 'react';

type ColorSchemeName = 'light' | 'dark' | null;

const QUERY = '(prefers-color-scheme: dark)';

const read = (): ColorSchemeName => {
  if (typeof window === 'undefined' || !window.matchMedia) {
    return null;
  }
  return window.matchMedia(QUERY).matches ? 'dark' : 'light';
};

export const useColorScheme = (): ColorSchemeName => {
  const [scheme, setScheme] = useState<ColorSchemeName>(read);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) {
      return;
    }
    const list = window.matchMedia(QUERY);
    const onChange = (event: MediaQueryListEvent): void => {
      setScheme(event.matches ? 'dark' : 'light');
    };
    list.addEventListener('change', onChange);
    return () => list.removeEventListener('change', onChange);
  }, []);

  return scheme;
};
